export default __webpack_public_path__ + "static/media/NandanBG.ae549644.webp";